import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import {
  getObjectDetail,
  getToolInputString,
  quotedDetail,
  quotedText,
} from "../shared";
import { getToolPartOutputRecord } from "./bedrock-shared";

function getCustomDomainStatusDetail({
  isPending,
  isStale,
}: {
  isPending: unknown;
  isStale?: unknown;
}) {
  if (isPending === true) return "pending DNS setup";
  if (isStale === true) return "stale DNS setup";
  return "active";
}

export function getCustomDomainDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const domain = getObjectDetail({
    properties: ["domain", "value"],
    value: outputRecord,
  });
  if (domain) {
    return `${quotedText({ value: domain })}, ${getCustomDomainStatusDetail({
      isPending: outputRecord?.isPending ?? !outputRecord?.isActive,
      isStale: outputRecord?.isStale,
    })}`;
  }

  const domains = Array.isArray(outputRecord?.domains)
    ? outputRecord.domains
    : null;
  if (domains) {
    if (domains.length === 0) {
      const siteSubdomain = getObjectDetail({
        properties: ["siteSubdomain"],
        value: outputRecord,
      });
      return siteSubdomain
        ? `for ${siteSubdomain} and found none`
        : "for this site and found none";
    }

    return `and found ${
      domains.length === 1
        ? "1 custom domain"
        : `${domains.length} custom domains`
    }`;
  }

  const inputDomain = getToolInputString({ properties: ["domain"], toolPart });
  return quotedDetail({ value: inputDomain });
}
